import { action } from '@reatom/framework'
import { match } from 'ts-pattern'

import { identity, pipe, Result } from '@blade/std-lib'
import { User } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { AuthErrorCode } from '@root/shared/api/api-error-code'

export const createOtpRequestAction = action(async (ctx) => {
  const { tradeApiClient } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.otp.userOtpList, []),
  )
  return result
}, 'createOtpRequestAction')

export const confirmOtpRequestAction = action(
  async (ctx, { code }: { code: string }) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.otp.userOtpCreate, [{ token: code }]),
    )
    return pipe(
      result,
      Result.map((it) => User.fromDto(it, assets.avatarsHost)),
    )
  },
  'confirmOtpRequestAction',
)
export const deleteOtpRequestAction = action(
  async (ctx, { code }: { code: string }) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.otp.userOtpDelete, [{ token: code }]),
    )
    return pipe(
      result,
      Result.mapError((e) =>
        match(e)
          .when(ApiError.isOfCodes([AuthErrorCode.InvalidOTP]), identity)
          .otherwise(() => e),
      ),
      Result.map((it) => User.fromDto(it, assets.avatarsHost)),
    )
  },
  'deleteOtpRequestAction',
)
